// All prices in this CMS are stored ex VAT (design decision 2026-07-29). The
// inc-VAT view a salesperson quotes to a restaurant is display-only arithmetic
// on the stored number — never persisted anywhere.
export const UAE_VAT_RATE = 0.05;

export type VatMode = 'inc' | 'ex';

export const withVat = (exVatPrice: number, mode: VatMode): number =>
  mode === 'inc' ? exVatPrice * (1 + UAE_VAT_RATE) : exVatPrice;

export const vatCaption = (mode: VatMode): string => (mode === 'inc' ? 'inc VAT' : 'ex VAT');

// URL param → mode. Anything that isn't explicitly 'ex' shows inc VAT — the
// default a restaurant conversation happens in.
export const resolveVatMode = (param: unknown): VatMode => (param === 'ex' ? 'ex' : 'inc');
